import { Component, JSX, onCleanup, onMount } from 'solid-js'

import './style/sticky.scss'

type StickyBtnT = {
    onclick?(): void
    class?: string
    label: string
    Icon?: JSX.Element
    type?: 'submit' | 'reset' | 'button' | 'menu' | undefined
}
const StickyBtn: Component<StickyBtnT> = P => {
    let btnRef: HTMLElement

    let targetX = 0,
        targetY = 0
    let currentX = 0,
        currentY = 0
    let animFrame = 0

    onMount(() => {
        const ac = new AbortController()

        btnRef.addEventListener('mousemove', mouseMove, {
            signal: ac.signal,
        })
        btnRef.addEventListener('mouseenter', mouseEnter, {
            signal: ac.signal,
        })
        btnRef.addEventListener('mouseleave', mouseLeave, {
            signal: ac.signal,
        })

        onCleanup(() => ac.abort())
    })

    function animate() {
        // ease current→target
        currentX += (targetX - currentX) * 0.05
        currentY += (targetY - currentY) * 0.05

        // normalized coords in range [-1,1]
        const nx = currentX / (btnRef.clientWidth / 2)
        const ny = currentY / (btnRef.clientHeight / 2)

        // twist amount: when both nx,ny are +1 (bottom-right), twist=+1*1*5° = +5deg
        // at top-left (-1,-1) also +5deg, etc.
        const twist = Math.max(-1, Math.min(1, nx * ny)) * 100 // clamp ±1 then ×5°

        btnRef.style.transform = `
    translate(${currentX}px, ${currentY}px)
    rotateX(${ny * -10}deg)
    rotateY(${nx * 10}deg)
    rotateZ(${twist * 5}deg)
  `

        if (
            Math.abs(targetX - currentX) > 0.5 ||
            Math.abs(targetY - currentY) > 0.5
        ) {
            animFrame = requestAnimationFrame(animate)
        } else {
            animFrame = 0
        }
    }

    const mouseMove = (e: MouseEvent) => {
        const pos = btnRef.getBoundingClientRect()
        // compute target offsets
        targetX = (e.clientX - pos.left - pos.width / 2) * 0.15
        targetY = (e.clientY - pos.top - pos.height / 2) * 0.07

        // btnRef.style.transition = ''

        if (!animFrame) animate()
    }
    const mouseEnter = () => {
        btnRef.style.transition = 'background 0.2s ease, color 0.2s ease'

        if (!animFrame) animate()
    }

    const mouseLeave = () => {
        targetX = targetY = 0

        btnRef.style.transition = ''
        btnRef.style.transform = ''

        cancelAnimationFrame(animFrame)
        animFrame = 0
    }

    return (
        <button
            onclick={() => P.onclick && P.onclick()}
            class={`sticky-btn-cmp  ${P.class || ''}`}
            ref={e => (btnRef = e)}
            type={P.type || 'button'}
        >
            {P.Icon}
            {P.label}
        </button>
    )
}

export { StickyBtn }
